import {
  Component,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';

@Component({
  selector   : 'wor-wizard-step',
  styles: [ require('./wizard.component.scss') ],
  template: require('./wizard.step.component.html')
})
export class WizardStepComponent {
  @Input() isSkippable = false;

  //WS-6780. The import's steps each have an action of their own: choose a file, confirm
  //the mapping, bring the rows in. Company set up's steps do not, so an empty label
  //leaves the footer exactly as it was and nothing about that wizard changes.
  @Input() actionLabel = '';

  //WS-6780. Whether this step has a footer action at all. Every step of company set up
  //does, which is why this defaults to true. The import's last two do not: answering the
  //questions and reading the result are the summary's own controls, and moving on is the
  //run's decision, not a button's. Rendering a disabled Next on those steps would put a
  //dead control where the operator looks for the live one.
  @Input() hasAction = true;

  //WS-6780. Whether this step will let the operator move on. Company set up answers that
  //from the form controls on the step, which is what null means here. The import cannot:
  //its first step is ready or not depending on whether a file has been read, and that is
  //not a form control at all. Null rather than false so "no opinion" stays distinct from
  //"not yet", because defaulting to false would disable Next on every existing wizard.
  @Input() canAdvance : boolean | null = null;


  @ViewChild('template', { read: TemplateRef, static: true })
  template!: TemplateRef<any>;
}
